import { validateProps } from '../../utils';
import { isValidBase } from '../BaseEntity';
export let RecurringScheduleStatus = /*#__PURE__*/function (RecurringScheduleStatus) {
  RecurringScheduleStatus["PENDING"] = "PENDING";
  RecurringScheduleStatus["ACTIVE"] = "ACTIVE";
  RecurringScheduleStatus["PAUSED_BY_CLIENT"] = "PAUSED_BY_CLIENT";
  RecurringScheduleStatus["PAUSED_BY_BUSINESS"] = "PAUSED_BY_BUSINESS";
  RecurringScheduleStatus["INACTIVE"] = "INACTIVE";
  RecurringScheduleStatus["INVALID"] = "INVALID";
  return RecurringScheduleStatus;
}({});
export let RecurringSchedulePattern = /*#__PURE__*/function (RecurringSchedulePattern) {
  RecurringSchedulePattern["ON_DEMAND"] = "ON_DEMAND";
  RecurringSchedulePattern["PRE_SCHEDULED"] = "PRE_SCHEDULED";
  return RecurringSchedulePattern;
}({});
// TODO: once API is fixed enable serviceId and providerId validation
export const isValidRecurringSchedule = properties => {
  const ans = isValidBase(properties) && validateProps(properties, ['pattern', 'status' /* 'serviceId' , 'providerId', */]);
  return ans;
};
export const isValidEnrichedRecurringSchedule = properties => {
  const ans = isValidRecurringSchedule(properties) && validateProps(properties, ['service', 'contacts', 'bookedAppointments', 'insights']);
  return ans;
};
//# sourceMappingURL=RecurringSchedule.js.map